import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Zoom from '@material-ui/core/Zoom';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../../containers/AuthUser';
import EquipmentAssignmentContainer from '../../../containers/EquipmentAssignment';

//- UI / Form
import LocationSelect from '../../advancedForm/LocationSelect';
import FormComponent from '../../FormComponent';
import { getGlobalClasses } from '../../../themes';
import Transition from '../Transition';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../../images/icons/greenChecked.svg';
import EquipmentSelect from '../../advancedForm/EquipmentSelect';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickToShow: {
			padding: 10,
			background: '#fEfEfE',
			border: '1px solid #ddd',
			color: '#333',
			borderRadius: 2,
		},
		notCurrentlyAssigned: {
			fontSize: 20,
			borderBottom: '1px solid #ddd',
			paddingBottom: 5,
			marginBottom: 10,
		},
		assignmentHelper: {
			padding: 20,
			border: '1px solid #eee',
			margin: 10,
			marginTop: 40,
			backgroundColor: '#f7f7f7',
			borderRadius: 5,
		},
		notSelectedLocation: {
			opacity: 0.3,
		},
		selectedLocation: {
			borderLeft: '3px solid #1289d4',
		},
		locationContainer: {
			padding: 10,
		},
		locationHeader: {
			borderBottom: '1px solid #ddd',
			paddingBottom: 5,
			marginBottom: 5,
		},
		location: {
			fontSize: '200%',
			paddingRight: 10,
		},
		locationCount: {
			fontWeight: 200,
			color: '#333',
		},
		locationTitle: {
			textTransform: 'uppercase',
			letterSpacing: 2,
			fontSize: 13,
			borderBottom: '1px solid #ddd',
			marginBottom: 20,
		},
		shiftTimeTruck: {
			marginLeft: 20,
			display: 'flex',
		},
		truckInfo: {
			color: '#555',
			fontWeight: 500,
			marginLeft: 5,
		},
		shiftTitle: {
			fontSize: '120%',
			marginLeft: 5,
		},
		smallSemiTruckIcon: {
			display: 'inline-block',
			width: 11,
			height: 11,
			verticalAlign: 'middle',
			marginRight: 5,
		},

		//dialog
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 20,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
			color: 'white',
			marginRight: 10,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isSaving: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		savingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
	};
};

class SaveEquipmentAssignmentDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			locationId: '',
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
		};
	}

	fillForm = ({ equipmentAssignment }) => {
		if (!equipmentAssignment) {
			return;
		}
		const newState = {};
		['equipmentAssignmentId', 'equipmentId', 'locationId'].forEach((key) => {
			if (_.isNil(equipmentAssignment[key])) {
				return;
			}
			newState[key] = equipmentAssignment[key];
		});
		this.setState(newState);
	};

	handleSave = () => {
		const {
			addEquipmentAssignment,
			updateEquipmentAssignment,
			showErrors,
			equipmentAssignmentToUpdate,
			//equipmentMap,
		} = this.props;
		const { equipmentId, locationId } = this.state;
		let isUpdate = equipmentAssignmentToUpdate ? true : false;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({ isSaving: true });

		const params = {
			equipmentId,
			locationId,
		};

		if (!isUpdate) {
			addEquipmentAssignment({
				params,
				callback: () => {
					this.setState({ isSaving: false });
				},
			});
		} else {
			params.equipmentAssignmentId = equipmentAssignmentToUpdate.equipmentAssignmentId;
			updateEquipmentAssignment({
				params,
				callback: () => {
					this.setState({ isSaving: false });
				},
			});
		}
	};

	render() {
		const {
			permissions,
			classes,
			open,
			onClose,
			equipmentAssignmentToUpdate,
			equipmentMap,
		} = this.props;
		if (!permissions || !_.includes(permissions, 'canUpdateScheduling')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}
		let isUpdate = equipmentAssignmentToUpdate ? true : false;

		let equipmentDisplay;
		if (isUpdate) {
			const equip = equipmentMap[equipmentAssignmentToUpdate.equipmentId] || {
				display: 'Missing truck name',
			};
			equipmentDisplay = equip.display;
		}

		console.log(equipmentAssignmentToUpdate);

		const { isSaving, savingSuccessful } = this.state;
		const action = isUpdate
			? `Update Truck ${equipmentDisplay} Assignmoent`
			: 'Create Truck Assignment';
		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>{action}</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>
					<div>
						<LocationSelect {...this.setForm('locationId', 'Terminal', true)} />

						{!isUpdate && (
							<EquipmentSelect
								{...this.setForm('equipmentId')}
								label={'Truck'}
								isPortal={true}
								groupBy="currentlyAssignedOrUnassigned"
								filterType="showOnlyUnassigned"
								onlyShowActive={true}
							/>
						)}

						<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
							<Button
								variant="contained"
								color="primary"
								className={classes.addButton}
								onClick={this.handleSave}
								disabled={isSaving}
							>
								{action}
							</Button>

							<Button variant="outlined" className={classes.button} onClick={onClose}>
								Cancel
							</Button>

							<Zoom
								in={isSaving}
								style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
								mountOnEnter
								unmountOnExit
							>
								<div className={classes.isSaving}>
									<CircularProgress style={{ verticalAlign: 'middle' }} />
									<span style={{ paddingLeft: 10 }}>Saving...</span>
								</div>
							</Zoom>

							<Zoom
								in={savingSuccessful}
								style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
							>
								<div className={classes.savingSuccessful}>
									<div className={classes.greenCheckedIcon} />
									<span style={{ paddingLeft: 10 }}>Save Successful.</span>
								</div>
							</Zoom>
						</Grid>
					</div>
				</div>
			</Dialog>
		);
	}
}

/*

	After you pick the vehicle it pulls information about hta vehicle
 */

SaveEquipmentAssignmentDialog.propTypes = {
	getEquipmentAssignment: PropTypes.func.isRequired,
	addEquipmentAssignment: PropTypes.func.isRequired,
	updateEquipmentAssignment: PropTypes.func.isRequired,
	equipmentAssignment: PropTypes.object,

	searchEquipmentAssignmentsByEquipment: PropTypes.func.isRequired,

	searchEquipmentAssignments: PropTypes.func.isRequired,
	equipmentAssignments: PropTypes.array,

	open: PropTypes.bool,
	onClose: PropTypes.func,
	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), AuthUserContainer, EquipmentAssignmentContainer])(
	SaveEquipmentAssignmentDialog
);
